// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"999a89dc","68":"ace04842","141":"7d418d04","193":"60d0244b","246":"80b14f1d","275":"aced5e93","368":"c1ed1d4b","395":"d1c4f1b3","636":"4f90ace3","863":"85adc244","896":"f8b6b662","976":"14cfed0e","986":"debe3497"}[chunkId] + ".chunk.js";
};